import { Client, Equipment, EquipmentIcon, Sector, Site } from '@umanforge/common';
import { Loading } from 'components/loading.component';
import { useTranslation } from 'react-i18next';
import { EquipmentComponent } from './equipment.component';

interface EquipmentsListProps {
  clients: Client[];
  sites: Site[];
  sectors: Sector[];
  equipments: Equipment[];
  isLoading: boolean;
  t: ( key: string ) => string;
}

export function EquipmentsList( props: EquipmentsListProps ) {
  const { t } = useTranslation();

  const {
    clients,
    sites,
    sectors,
    equipments,
    isLoading,
  } = props;


  if ( isLoading ) { return <Loading/>; }

  return (
    <div className='flex flex-col gap-10 justify-center w-full h-full'>
      {
        equipments.length > 0 ?
          <div className='flex flex-wrap w-full justify-center'>
            {
              equipments.map( equipment => {
                const sector = sectors.find( item => { return item.id === equipment.sectorId; } );
                const site = sites.find( item => { return item.id === sector?.siteId; } );
                const client = clients.find( item => { return item.id === site?.clientId; } );
                return (
                  <EquipmentComponent
                    key={ equipment.id }
                    equipment={ equipment }
                    siteOfSector={ site }
                    sectorOfEquipment={sector}
                    clientOfSite={ client }
                    t={ t }
                  />
                );
              } )
            }
          </div>
          :
          <div className='flex flex-col gap-4 w-full h-full pt-10 items-center justify-center'>
            <EquipmentIcon className='h-24 w-24'/>
            <div className='flex flex-col items-center justify-center'>
              <span className='font-bold'>{t( 'common:oops' ) }</span>
              <span className='font-medium'>{ t( 'no_equipments_found' ) }</span>
            </div>
          </div>
      }
    </div>
  );

}